<template>
  <div class="full-detail">
    <h1>{{ publication.title }}</h1>
    <p class="authors">
      By
      <router-link
        v-for="author in publication.authors"
        :to="`/author/${author.guid}`"
        :key="author.guid"
      >
        {{ author.name }}
      </router-link>
    </p>
    <p>
      <a :href="publication.url" class="pure-button" target="buy">Buy</a>
      <a
        :href="
          `https://books.google.co.uk/books?id=${publication.googlebooks}&printsec=frontcover&source=gbs_ViewAPI`
        "
        class="pure-button"
        target="preview"
        >Preview</a
      >
    </p>
    <p class="long-description">
      <img :src="publication.picture_url" />{{ publication.description }}
    </p>
    <h2>Publisher</h2>
    <p>{{ publication.publisher }}</p>
    <p><button @click="$emit('close')" class="pure-button">Close</button></p>
  </div>
</template>
<style scoped>
.full-detail {
  margin: 1rem 1rem 3rem 1rem;
}
h1,
h2 {
  margin: 1rem 1rem 0 1rem;
}
p {
  margin: 0 1rem 1rem 1rem;
  line-height: 1.6;
}
h2 {
  clear: both;
}
img {
  float: right;
  border: 1px solid black;
  margin: 5px 0 15px 15px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  max-width: 150px;
}
.long-description {
  white-space: pre-wrap;
  max-height: 500px;
  overflow-y: auto;
}
</style>
<script>
import axios from "axios";
import Vue from "vue";

export default {
  name: "fullPublicationDetails",
  data() {
    return {
      publication: {},
    };
  },
  props: ["publicationId"],
  async mounted() {
    this.getPublication();
  },
  methods: {
    getPublication() {
      axios
        .get(`/publication/${this.publicationId}`)
        .then((response) => (this.publication = response.data));
    },
  },
};
</script>
